import React from "react";
import { useAuth } from "../../hooks/AuthProvider";

const styles = {
  pageContainer: {
    display: "flex",
    width: "100vw",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #000000 0%, #1a1a2e 50%, #16213e 100%)",
  },
  
  container: {
    width: "100%",
    maxWidth: "420px",
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(65, 105, 225, 0.2)",
    boxShadow: "0 0 30px rgba(65, 105, 225, 0.3)",
    borderRadius: "16px",
    overflow: "hidden",
  },

  content: {
    padding: "32px",
    textAlign: "center" as const,
  },

  title: {
    fontSize: "1.875rem",
    fontWeight: "bold",
    marginBottom: "1rem",
    color: "#ffffff",
  },

  message: {
    color: "#D1D5DB",
    fontSize: "16px",
    lineHeight: "1.6",
    marginBottom: "24px",
  },

  link: {
    color: "#4F46E5",
    textDecoration: "underline",
    fontWeight: "500",
  },

  logoutButton: {
    width: "100%",
    padding: "12px 24px",
    marginTop: "16px",
    fontSize: "16px",
    fontWeight: "500",
    color: "#ffffff",
    backgroundColor: "#e53e3e",
    border: "1px solid #e53e3e",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

const Unauthorized: React.FC = () => {

    const { logout } = useAuth();


  const handleLogout = () => {

    logout("/login");

  };

  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>Unauthorized</h1>
          <p style={styles.message}>
            You are not authorized to view this page. Please{" "}
            <a 
              href="https://dineplatform.com/contact" 
              style={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              get in touch
            </a>{" "}
            to get started.
          </p>
          <button 
            onClick={handleLogout}
            style={styles.logoutButton}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;